import React from 'react';
import PropTypes from 'prop-types';

import KittenInTab from './KittenInTab';
import Arrow from '../Arrow';

function HeroIllustration({ buttonHover }) {
	return (
		<div className="hero--illustration">
			<div className="toolbar">
				<div className="dot" />
				<div className="dot" />
				<div className="dot" />
			</div>
			<div className="hero--cats">
				<KittenInTab beingPet={buttonHover} color="gray" />
				<KittenInTab beingPet={buttonHover} color="white" />
				<KittenInTab beingPet={buttonHover} color="orange" />
				<KittenInTab beingPet={buttonHover} color="black" />
			</div>
			<div className="window">
				<Arrow />
			</div>
		</div>
	);
}

HeroIllustration.propTypes = {
	buttonHover: PropTypes.bool,
};

HeroIllustration.defaultProps = {
	buttonHover: false,
};

export default HeroIllustration;



// WEBPACK FOOTER //
// ./src/components/Site/Home/HeroIllustration.js